'use client'
import { Typography } from 'components/Contentful'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import styles from './RelatedArticles.module.scss'
import { _get } from 'utils/shared'
import { Divider } from '@achieve/ascend'
import { mainProductConfig } from 'constants/mainProductConfig'
import {} from 'react'
import classNames from 'classnames'

function RelatedArticles({ relatedArticles, completePageUrl, title, buttons }) {
  const baseHref = completePageUrl.slice(0, completePageUrl.lastIndexOf('/') + 1)
  const articleArray = _get(relatedArticles, 'items')
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'

  return (
    <div className={styles['related-articles-container']}>
      {title ? (
        title
      ) : (
        <Typography
          content={'Other articles you may be interested in'}
          className={classNames(
            styles['header'],
            'headingMd lg:displayMd font-medium! lg:font-light!'
          )}
        />
      )}
      {articleArray &&
        articleArray.map((article, articleIndex) => {
          const { title, slug, externalLink } = article.fields
          const articleLink = externalLink ? `${externalLink}` : baseHref.concat(slug)

          return (
            <div className={styles['single-article-container']} key={slug}>
              <div className={styles['title-link-container']}>
                <AchieveLink
                  href={articleLink}
                  className={styles['title-link']}
                  track={{
                    list_name: 'Right Rail Title',
                    click_id: title,
                    click_position: articleIndex,
                    click_text: `${
                      mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                    } | ${title}`,
                    nav_link_section: 'Suggested Content - Right Rail',
                    track_event: 'page_nav_click',
                    event_action: 'link_click',
                    event_type: 'link_click',
                  }}
                >
                  <Typography
                    content={title}
                    variant="bodyLg"
                    className={styles['title']}
                    fontWeight="medium"
                  />
                </AchieveLink>
              </div>

              <AchieveLink
                href={articleLink}
                className={styles['cta-link']}
                track={{
                  list_name: 'Right Rail Read More',
                  click_id: title,
                  click_position: 'Read the article',
                  click_text: `${
                    mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                  } | Read the article`,
                  nav_link_section: 'Suggested Content - Right Rail',
                  track_event: 'page_nav_click',
                  event_action: 'link_click',
                  event_type: 'link_click',
                }}
              >
                <Typography
                  content={buttons ? buttons : 'Read the article'}
                  variant="bodyLg"
                  fontWeight="bold"
                />
              </AchieveLink>

              {articleIndex !== articleArray.length - 1 && (
                <Divider className={styles['divider']} />
              )}
            </div>
          )
        })}
    </div>
  )
}

export { RelatedArticles }
